import React from "react";
import { Dialog } from "@material-ui/core";

const Menu = (props) => {
  const {
    open,
    onClose,
    myAnimation,
    activeTab,
    globalState,
    languagesList,
    setActiveLang,
    langHandler,
    langFlag,
  } = props;
  return (
    <Dialog
      //   classes={{ paper: storeClasses.dialogPaper3 }}
      open={open}
      onClose={() => onClose(false)}
    >
      <div
        style={{
          width: "100vw",
          height: "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <div
          onClick={() => onClose(false)}
          style={{
            width: 20,
            height: 20,
            backgroundColor: "#fff",
            cursor: "pointer",
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="prefix__close"
            width="22"
            height="22"
            viewBox="0 0 14.857 14.857"
          >
            <g id="prefix__Group_2439" data-name="Group 2439">
              <path
                id="prefix__Path_2455"
                fill="#3b4257"
                d="M8.249 7.429L14.686.991a.58.58 0 0 0-.821-.821L7.428 6.608.99.171a.58.58 0 0 0-.82.82l6.437 6.438L.17 13.867a.58.58 0 0 0 .821.821L7.428 8.25l6.438 6.438a.58.58 0 0 0 .821-.821z"
                data-name="Path 2455"
                transform="translate(0 -.001)"
              />
            </g>
          </svg>
        </div>
        {langFlag ? (
          languagesList?.map((lang, index) => (
            <span
              onClick={() => {
                // setTimeout(() => {
                //   onClose(false);
                // }, 1);
                onClose(false);
                setActiveLang(lang);
                langHandler(lang.key);
              }}
              className="langRowContainer  switchLangModal"
              style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "80%",
                padding: "10px",
                borderBottom: index !== 3 ? "1px solid #d3d3d3" : "",
                height: "45px",
              }}
            >
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                {lang?.title}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  paddingRight:
                    globalState.themeDirection === "ltr" ? "0px" : "25px",
                  paddingLeft:
                    globalState.themeDirection === "ltr" ? "25px" : "0px",
                  fontWeight: 700,
                }}
              >
                {lang?.abbreviation}
              </span>
            </span>
          ))
        ) : (
          <>
            <span
              onClick={() => {
                myAnimation(0, activeTab, { title: undefined }, false);
                onClose(false);
              }}
              style={{
                height: "50px",
                width: "100%",
                margin: 0,
                fontWeight: "600",
                color: "#727d93",
                fontSize: "16px",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              صفحه اول
            </span>
            <span
              onClick={() => {
                myAnimation(0, activeTab, { title: undefined }, true);
                onClose(false);
              }}
              style={{
                height: "50px",
                width: "100%",
                margin: 0,
                fontWeight: "600",
                textAlign: "center",
                fontSize: "16px",
                color: "#727d93",
                cursor: "pointer",
              }}
            >
              ارتباط با ما
            </span>
            <span
              onClick={() => {
                window.location = "https://www.instagram.com/ghalichsin.ir/";
                onClose(false);
              }}
              style={{
                height: "50px",
                width: "100%",
                margin: 0,
                fontWeight: "600",
                textAlign: "center",
                fontSize: "16px",
                color: "#727d93",
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="21"
                viewBox="0 0 22 21"
              >
                <g fill="none" fill-rule="evenodd">
                  <g fill="#727D93">
                    <g>
                      <path
                        d="M14.543 0H6.17C2.768 0 0 2.768 0 6.17v8.372c0 3.403 2.768 6.171 6.17 6.171h8.372c3.403 0 6.171-2.768 6.171-6.17V6.17c0-3.403-2.768-6.171-6.17-6.171zm4.086 14.543c0 2.256-1.83 4.086-4.087 4.086H6.171c-2.258 0-4.087-1.83-4.087-4.087V6.171c0-2.258 1.83-4.087 4.087-4.087h8.372c2.257 0 4.086 1.83 4.086 4.087v8.372z"
                        transform="translate(-307 -60) translate(307.161 60)"
                      />
                      <path
                        d="M10.357 5c-2.954 0-5.358 2.403-5.358 5.356 0 2.954 2.404 5.358 5.358 5.358 2.954 0 5.357-2.404 5.357-5.358C15.714 7.402 13.31 5 10.357 5zm0 8.63c-1.808 0-3.274-1.466-3.274-3.274 0-1.807 1.466-3.273 3.274-3.273 1.807 0 3.273 1.466 3.273 3.274 0 1.807-1.466 3.273-3.274 3.273zM15.724 3.756c.709 0 1.284.575 1.284 1.284 0 .708-.575 1.283-1.284 1.283-.709 0-1.284-.575-1.284-1.283 0-.709.575-1.284 1.284-1.284z"
                        transform="translate(-307 -60) translate(307.161 60)"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span
              onClick={() => {
                window.location = "https://twitter.com/ghalichin?s=08";
                onClose(false);
              }}
              style={{
                height: "50px",
                width: "100%",
                margin: 0,
                fontWeight: "600",
                textAlign: "center",
                fontSize: "16px",
                color: "#727d93",
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="19"
                viewBox="0 0 22 19"
                style={{ margin: 0 }}
              >
                <g fill="none" fill-rule="evenodd">
                  <g fill="#727D93">
                    <path
                      d="M280.742 63.63c-.468.207-.954.371-1.453.49.55-.523.963-1.176 1.196-1.905.067-.208-.16-.388-.348-.277-.694.412-1.441.72-2.221.918-.046.011-.092.017-.14.017-.141 0-.28-.052-.388-.148-.83-.732-1.898-1.135-3.007-1.135-.48 0-.964.075-1.44.222-1.473.457-2.61 1.673-2.966 3.172-.134.563-.17 1.126-.108 1.673.007.063-.023.107-.041.128-.032.036-.078.057-.126.057l-.016-.001c-3.225-.3-6.133-1.853-8.19-4.375-.104-.129-.305-.113-.389.03-.402.69-.615 1.48-.615 2.285 0 1.231.495 2.392 1.355 3.239-.362-.086-.712-.22-1.037-.401-.157-.088-.35.025-.353.204-.022 1.83 1.05 3.459 2.654 4.192l-.097.001c-.254 0-.512-.024-.765-.073-.177-.034-.326.134-.271.306.52 1.627 1.921 2.826 3.597 3.098-1.39.933-3.01 1.426-4.696 1.426h-.526c-.162 0-.299.105-.34.262-.04.154.034.317.172.398 1.9 1.105 4.067 1.69 6.267 1.69 1.927 0 3.729-.383 5.356-1.137 1.492-.69 2.81-1.679 3.919-2.936 1.032-1.171 1.84-2.523 2.4-4.019.533-1.425.815-2.946.815-4.398v-.07c0-.232.105-.452.29-.601.697-.567 1.305-1.234 1.806-1.983.132-.198-.076-.446-.294-.35z"
                      transform="translate(-260 -61)"
                    />
                  </g>
                </g>
              </svg>
            </span>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default Menu;
